export default "__VITE_ASSET__Dil9Zj1l__"